export const DRAFT_KEY_PREFIX = 'dcma-pbp-draft:';

export function clearDcmaPbpBrowserDrafts(): void {
  try {
    for (let index = window.sessionStorage.length - 1; index >= 0; index -= 1) {
      const key = window.sessionStorage.key(index);
      if (key?.startsWith(DRAFT_KEY_PREFIX)) {
        window.sessionStorage.removeItem(key);
      }
    }
  } catch {
    // Browser storage is best effort; server-saved review data is unaffected.
  }
}
